import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PatchCommunication,
	PatchCommunicationParams,
} from 'domain/usecases/private/communications/patch-communication';

export class RemotePatchCommunication implements PatchCommunication {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<void>,
	) {}

	async patch(params: PatchCommunicationParams): Promise<void> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			body: params || {},
			method: 'patch',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
